import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemNumber({ field, fieldValue, label }: CustomFieldListItemProps) {
  const title = fieldValue?.value_int != null ? `${fieldValue.value_int}` : "-";
  return <ListItem preTitle={label ?? field.title} title={title} />;
}
